import { render } from "./dashboard-mutirao.vue?vue&type=template&id=ca08f814&scoped=true"
import script from "./dashboard-mutirao.js?vue&type=script&lang=js&external"
export * from "./dashboard-mutirao.js?vue&type=script&lang=js&external"

import "./dashboard-mutirao.scss?vue&type=style&index=0&id=ca08f814&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca08f814"]])

export default __exports__